/**
 * @class Analytics
 * A simple wrapper for sending ga events
 * Add data-ga="category|action|label" to any element
 * to track it as an event when clicked
 */
export default class Analytics {
  constructor() {
    this.$elements = document.querySelectorAll('[data-ga]');
    this.$elements.forEach(element => this.setupElement(element));
  }

  /**
   * @function setupElement
   * @param {HTMLElement} el
   */
  setupElement(el) {
    el.addEventListener('click', () => {
      const parts = el.dataset.ga.split('|');

      const category = parts[0];
      const action = parts[1];
      const label = parts[2];

      // Send the GA event
      this.constructor.send(category, action, label);
    });
  }

  /**
   * @funtion send
   * @param {String} category
   * @param {String} action
   * @param {String} label
   */
  static send(category, action, label) {
    if (!window.ga) return;
    window.ga('send', 'event', category, action, label);
  }
}
